import InboundRequestLogRepository from "../repository/inbound-request-log-repository";

class InboundRequestLogService
{
    #inboundRequestLogRepository;

    constructor() {
        this.#inboundRequestLogRepository = new InboundRequestLogRepository();
    }

    async findOne(id) {
        try {
            const data = await this.#inboundRequestLogRepository.getOneById(id);

            return data;
        } catch (error) {
            console.error(error);
        }
    }

    async gridview(query) {
        try {
            const data = await this.#inboundRequestLogRepository.gridview(query);

            return data;
        } catch (error) {
            console.error(error);
        }
    }
}

export default InboundRequestLogService;